import { FormEvent, useState } from 'react'

export function useInput (initValue: any) {
  const [ value, setValue ] = useState(initValue)

  const onChange = function (e: FormEvent<HTMLInputElement> | string) {
    if (typeof e === 'string') {
      return setValue(e)
    }
    setValue(e.currentTarget.value)
  }

  return [
    value,
    onChange
  ]
}
